import { capitalize } from '../../common/utils/common.util';
import { FilterConfigLookupOption } from '../custom-filter-panel/DynamicFilters';
import { City, County, CustomArea, State } from './lookups.type';

export const getCityString = (city: City) => {
  const parts = [];
  parts.push(capitalize(city.name));
  if (city.state) parts.push(city.state?.stateCode?.toUpperCase());
  return parts.join(', ');
};

export const getStateLabel = (state: State) => capitalize(state.name);

export const isValidCityState = (cityOptions: City[], city?: string | null, state?: string | null) => {
  if (!city && !state) return true;
  if (!city || !state) return false;
  if (cityOptions.length === 0) return true;
  const normalizedCity = city.trim().toLowerCase();
  const normalizedState = state.trim().toLowerCase();
  return cityOptions.some(
    c =>
      c.name.toLowerCase() === normalizedCity &&
      (c.state?.name?.toLowerCase() === normalizedState || c.state?.stateCode?.toLowerCase() === normalizedState),
  );
};

export const getCountyString = (county: County) => {
  const parts = [];
  parts.push(capitalize(county.name));
  if (county.state) parts.push(county.state?.stateCode?.toUpperCase());
  return parts.join(', ');
};

export const mapStateLookup = (stateLookup: State): FilterConfigLookupOption => ({
  label: capitalize(stateLookup.name) ?? stateLookup.name,
  value: stateLookup.name,
});

export const mapCityLookup = (cityLookup: City): FilterConfigLookupOption => ({
  label: getCityString(cityLookup),
  value: getCityString(cityLookup),
});

export const mapCountyLookup = (countyLookup: County): FilterConfigLookupOption => ({
  label: getCountyString(countyLookup),
  value: getCountyString(countyLookup),
});

export const mapCustomAreaLookup = (customAreaLookup: CustomArea): FilterConfigLookupOption => ({
  label: customAreaLookup.name,
  value: customAreaLookup.name,
});
